import { useEffect } from 'react';
import usePrevious from './usePrevious';

/**
 * This is a simple alternative to useEffect when you only want to listen for changes in
 * one value and not have to pass in a dependency array. The callback also returns the
 * current value and the previous value so is also useful for shorting lo
 */
const useOnChange = <T>(cb: (currentValue: T, previousValue?: T) => void, dep: T) => {
  const prevVal = usePrevious(dep);
  useEffect(() => {
    if (prevVal !== dep) {
      cb(dep, prevVal);
    }
  }, [cb, dep, prevVal]);
};

// **** Export **** //

export default useOnChange;
